import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

const DismissibleCard = ({ width = 57, height = 38 }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d)">
      <rect x="55" width="34" height="53" rx="2" transform="rotate(90 55 0)" fill="#EE4266" />
      <path d="M46.7617 4.52441L50.3808 8.14346" stroke="#EE9EAE" strokeLinecap="round" />
      <path d="M50.3809 4.52441L46.7618 8.14346" stroke="#EE9EAE" strokeLinecap="round" />
      <rect x="19" y="19" width="19.9048" height="1.80952" rx="0.904762" fill="#EE9EAE" />
      <rect x="13" y="23.5236" width="31.6667" height="0.904762" rx="0.452381" fill="#EE9EAE" />
      <rect x="13" y="26.2383" width="31.6667" height="0.904762" rx="0.452381" fill="#EE9EAE" />
      <circle cx="28.1667" cy="12.2145" r="3.16667" fill="#F5D5DC" />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0"
        width={width}
        height={height}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default DismissibleCard;
